import React, { useEffect, useState } from "react";
import { ApiCaller } from "../../config/api/api";
const Gallery = () => {
  const [menuData, setMenuData] = useState([]);

  useEffect(() => {
    const fetchGalleryMenu = async () => {
      try {
        const data = await ApiCaller("food-gallery/", "GET");

        setMenuData(data?.results || []);
      } catch (error) {
        console.error('"Error at gallery Api', error.message);
      }
    };

    fetchGalleryMenu();
  }, []);

  return (
    <section className="py-14 px-5 sm:px-14 md:px-16 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {menuData.map((item, index) => (
          <div key={item.id || index} className="group">
            <div className="overflow-hidden rounded-lg transition-shadow duration-300">
              <img
                src={item.image_url}
                alt={`Gallery ${index + 1}`}
                className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
